/**
 * DOM id of the slot in the site header where the mobile order progress is portaled.
 *
 * @see AOrderProgressBar — `createPortal(..., document.getElementById(...))`
 */
export const ORDER_FLOW_MOBILE_HEADER_EXTRA_ELEMENT_ID = 'mobile-header-extra' as const
